import React from 'react';
import {Box, Typography} from '@mui/material';
import SettingIcon from '@mui/icons-material/SettingsOutlined';
import './../Demo.scss';

import ArrIconButton from '../../../components/common/arr-icon-button/ArrIconButton';

const IconButton: React.FC = () => {
  return (
    <Box p={3} className="abcd">
      <Typography variant="h5" gutterBottom>
        ArrIconButton Demo
      </Typography>

      {/* Default Shape */}
      <Box display="flex" justifyContent="center" gap={2} mb={3} className="bb">
        <ArrIconButton
          icon={<SettingIcon />}
          onClick={() => console.log('clicked')}
          ariaLabel="search"
          shape="default"
          size="small"
        />
        <ArrIconButton
          icon={<SettingIcon />}
          onClick={() => console.log('clicked')}
          ariaLabel="star"
          shape="default"
          size="medium"
        />
        <ArrIconButton
          icon={<SettingIcon />}
          onClick={() => console.log('clicked')}
          ariaLabel="cancel"
          shape="default"
          size="large"
        />
      </Box>

      {/* No Shape */}
      <Box display="flex" justifyContent="center" gap={2} mb={3}>
        <ArrIconButton
          icon={<SettingIcon />}
          onClick={() => console.log('clicked')}
          ariaLabel="play"
          shape="none"
          size="small"
        />
        <ArrIconButton
          icon={<SettingIcon />}
          onClick={() => console.log('clicked')}
          ariaLabel="play"
          shape="none"
          size="medium"
        />
        <ArrIconButton
          icon={<SettingIcon />}
          onClick={() => console.log('clicked')}
          ariaLabel="play"
          shape="none"
          size="large"
        />
      </Box>

      {/* Disabled State */}
      <Box display="flex" justifyContent="center" gap={2}>
        <ArrIconButton
          icon={<SettingIcon />}
          onClick={() => {}}
          ariaLabel="disabled search"
          size="small"
          shape="none"
          disabled
        />
        <ArrIconButton
          icon={<SettingIcon />}
          onClick={() => {}}
          ariaLabel="disabled search"
          size="medium"
          shape="none"
          disabled
        />
        <ArrIconButton
          icon={<SettingIcon />}
          onClick={() => {}}
          ariaLabel="disabled play"
          shape="none"
          size="large"
          disabled
          className="sans"
        />
      </Box>

      {/* using tooltip and custom class */}
      <Box display="flex" justifyContent="center" gap={2}>
        <ArrIconButton
          icon={<SettingIcon />}
          onClick={() => console.log('clicked')}
          ariaLabel="search"
          shape="default"
          size="small"
          className="icon-button AlterIcon"
        />
        <ArrIconButton
          icon={<SettingIcon />}
          onClick={() => console.log('clicked')}
          ariaLabel="search"
          shape="default"
          size="small"
          tooltipContent="Settings"
          tooltipPlacement="top"
          tooltipTrigger="hover"
          showTooltipOnTruncate={true}
        />
        <ArrIconButton
          icon={<SettingIcon />}
          onClick={() => console.log('clicked settings')}
          ariaLabel="settings"
          tooltipContent="Open Settings"
          tooltipPlacement="bottom"
        />
      </Box>
    </Box>
  );
};

export default IconButton;
